import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import MobileCallBar from "./components/MobileCallBar";
import Home from "./pages/Home";
import Financing from "./pages/Financing";
import CurrentListings from "./pages/CurrentListings";
import ClosedSales from "./pages/ClosedSales";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import ReviewRedirect from "./pages/ReviewRedirect";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/financing" element={<Financing />} />
            <Route path="/current-listings" element={<CurrentListings />} />
            <Route path="/closed-sales" element={<ClosedSales />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/review" element={<ReviewRedirect />} />
          </Routes>
        </main>
        <Footer />
        {/* Spacer so the fixed mobile call bar never covers footer content */}
        <div className="lg:hidden h-20" aria-hidden="true" />
        <MobileCallBar />
      </BrowserRouter>
    </div>
  );
}

export default App;
